import { css } from "@emotion/react";
import { typography } from "aviary-tokens";

export const freeText = css`
  text-transform: uppercase;
  font-weight: ${typography.weightBold};
`;

export const textAlign = css`
  text-align: center;
  width: 100%;
`;

export const designationRow = css`
  display: flex;
  align-items: center;
  padding: 0 1rem;
`;

export const continueWithButton = css`
  margin-top: 1rem;
`;

export const subTitle = css`
  margin-top: 0.5rem;
  margin-bottom: 1rem;
  text-align: center;
`;

export const peerReferralTitle = css`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 1rem;
`;

export const userAvatar = css`
  margin-right: 0.5rem;
`;

export const signUpFooterSection = css`
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const fullWidth = css`
  width: 100%;
`;
